import ExchangesContainer from "../container/ExchangesContainer";

const Exchanges = () => {
  return <ExchangesContainer/>
};

export default Exchanges;
